import { InfoIcon } from '@/components/icons';
import { Tooltip } from '@/components/ui';
import { useTheme } from '@/hooks';
import { TooltipProps } from '@chakra-ui/react';

import cn from 'classnames';
import styles from './info-tooltip.module.sass';

export type InfoTooltipProps = Omit<TooltipProps, 'children'>;

export const InfoTooltip = (props: InfoTooltipProps) => {
  //
  const { placement = 'top', ...rest } = props;
  const { themeClass } = useTheme();

  return (
    <Tooltip openDelay={100} placement={placement} {...rest}>
      <InfoIcon className={cn(styles.InfoTooltip, styles[themeClass])} />
    </Tooltip>
  );
};
